import choVayConst from "constants/choVayConst";
import { LaiSuatText2 } from "constants/choVayConst";
import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const ThongTinThanhly = ({ hopdong }) => {
  return (
    <>
      <div className="form-body form-bordered-1">
        <div class="from-thongtintra">
          <p>
            <div className="row">
              <div className="col-4 color7-bold"> Thanh toán cho hợp đồng:</div>
              <div className="col-8 text-left  text-normal color-xanh-bold">
                {hopdong.Code}
              </div>
            </div>
          </p>
          <p>
            <div className="row">
              <div className="col-4 color7-bold"> Tên khách hàng:</div>
              <div className="col-8 text-left  text-normal">
                {hopdong.CustomerName}
              </div>
            </div>
          </p>
          <p>
            <div className="row">
              <div className="col-4 color7-bold"> Số tiền vay:</div>
              <div className="col-8 text-left  text-normal color-do-bold">
                {formatNumber(hopdong.Sotienvay)}{" "}
                <span className="black-price">(vnđ)</span>
              </div>
            </div>
          </p>
          <p>
            <div className="row">
              <div className="col-4 color7-bold"> Ngày vay:</div>
              <div className="col-8 text-left  text-normal">
                {getDate(hopdong.NgayVay)}
              </div>
            </div>
          </p>
          <p>
            <div className="row">
              <div className="col-4 color7-bold"> Ngày trả:</div>
              <div className="col-8 text-left  text-normal">
                {getDate(hopdong.NgayTra)}
              </div>
            </div>
          </p>
          {hopdong.Type !== 2 && (
            <p>
              <div className="row">
                <div className="col-4 color7-bold"> Lãi suất:</div>
                <div className="col-8 text-left  text-normal">
                  {choVayConst.KieuLaiSuatText[hopdong.KieuLaiSuat]}:{" "}
                  {LaiSuatText2(hopdong, hopdong.KieuLaiSuat)}
                </div>
              </div>
            </p>
          )}
          {hopdong.Type === 2 && (
            <p>
              <div className="row">
                <div className="col-4 color7-bold"> Lãi suất:</div>
                <div className="col-8 text-left  text-normal">
                  {hopdong.StatusPaidHo === 1 &&
                    formatNumber(
                      Math.ceil(hopdong.ValueLai * hopdong.CountTypePaid)
                    ) + "đ"}
                  {hopdong.StatusPaidHo === 2 &&
                    formatNumber(
                      Math.ceil(hopdong.ValueLai * hopdong.BocTrongVong)
                    ) + "đ"}
                  {hopdong.StatusPaidHo === 3 &&
                    hopdong.ChiPhiVay.toFixed(2) + "%"}
                </div>
              </div>
            </p>
          )}
          <p>
            <div className="row">
              <div className="col-4 color7-bold"> Kiểu vay:</div>
              <div className="col-8 text-left  text-normal">
                {choVayConst.TypeText[hopdong.Type]}
              </div>
            </div>
          </p>
          <p>
            <div className="row">
              <div className="col-4 color7-bold"> Ghi chú:</div>
              <div className="col-8 text-left  text-normal">{hopdong.Note}</div>
            </div>
          </p>
        </div>
      </div>
    </>
  );
};
